import Draggable from 'react-draggable'; // https://github.com/react-grid-layout/react-draggable

export default Draggable.default || Draggable;